import BTemplate from "../../modules/BTemplate";
import BDiaryDayEntry from "./BDiaryDayEntry";

export default class BDiaryDaySection
{
	constructor(el)
	{
		this.el = el;
	}

	getEntries()
	{
		let entries = [];
		this.el.querySelectorAll(`.profile-entry`).forEach(el => {
			entries.push(new BDiaryDayEntry(el));
		});

		return entries;
	}

	getPreloderTemplate()
	{
		return new BTemplate(this.el.querySelector(`.preloader-template`));
	}

	setEntriesHtml = function(template) {
		this.el.querySelector(`.profile-entries`).innerHTML = template;
	}

	hide()
	{
		this.el.setAttribute("hidden", "");
		this.el.classList.add("hidden");
	}

	show()
	{
		this.el.removeAttribute("hidden");
		this.el.classList.remove("hidden");
	}
}
